import React from "react";
import Navbar from "../components/layout/Navbar";
import Footer from "../components/home/Footer";
import JobsHero from "../components/jobs/JobsHero";
import JobsCategories from "../components/jobs/JobsCategories";
import JobsWhyWorkWithUs from "../components/jobs/JobsWhyWorkWithUs";
import JobsHowToApply from "../components/jobs/JobsHowToApply";
import JobsContactOptions from "../components/jobs/JobsContactOptions";

const Jobs = () => {
  return (
    <div className="min-h-screen bg-white overflow-x-hidden">
      <Navbar />
      <JobsHero />
      <JobsCategories />
      <JobsWhyWorkWithUs />
      <JobsHowToApply />
      <JobsContactOptions />
      <Footer />
    </div>
  );
};

export default Jobs;